import type { QueryClient } from "@tanstack/react-query";
import { dropinApi } from "@bw/shared/api";
import type { CourtBoardResponse } from "@bw/shared/types/generated";

import { queryKeys } from "../../../common/query/queryClient";

export function courtBoardQueryOptions(
  queryClient: QueryClient,
  facilityId: string,
) {
  const queryKey = queryKeys.dropin.courtBoard(facilityId);
  return {
    queryKey,
    queryFn: async (): Promise<CourtBoardResponse> => {
      const incoming = await dropinApi.getCourtBoard(facilityId);
      const current = queryClient.getQueryData<CourtBoardResponse>(queryKey);
      return current && current.revision > incoming.revision
        ? current
        : incoming;
    },
  };
}
